<template>
  <div class="relative w-full">
    <div
      class="absolute flex flex-col rounded-sm py-2 pl-10 pr-5"
      :class="innerClasses ? innerClasses : ''"
      style="
        background-image: linear-gradient(
          135deg,
          transparent 9px,
          var(--surface-secondary) 10px
        );
      "
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  innerClasses?: string;
}
defineProps<Props>();
</script>
